var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body",on:{"click":_vm.onClick}},[_c('div',{staticClass:"body card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('p',[_c('span',{staticClass:"type",style:('--n:5000')},[_vm._v(_vm._s(_vm.text)+" ")])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }